/**
 * Style props for form field error message
 * @property {("primary" | "danger" | "danger2" | "dark-grey")} [textColor] - Error text color
 * @property {("2xs" | "xs" | "sm" | "base")} [fontSize] - Font size of the error message
 * @property {("none" | "sm" | "md" | "lg")} [marginTop] - Top margin of error message
 * @property {string} [className] - Additional Tailwind classes
 */
export interface InputErrorStyleProps {
  textColor?: "primary" | "danger" | "danger2" | "dark-grey";
  fontSize?: "2xs" | "xs" | "sm" | "base";
  marginTop?: "none" | "sm" | "md" | "lg";
  className?: string;
}

export const defaultInputErrorStyles: InputErrorStyleProps = {
  textColor: "primary",
  fontSize: "sm",
  marginTop: "sm",
};

export const inputErrorStylesMap = {
  fontSize: {
    "2xs": "text-2xs",
    xs: "text-xs",
    sm: "text-sm",
    base: "text-base",
  },
  marginTop: {
    none: "mt-0",
    sm: "mt-1",
    md: "mt-2",
    lg: "mt-3",
  },
} as const;
